import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=074731a2&"
import script from "./VideoCall.vue?vue&type=script&lang=ts&"
export * from "./VideoCall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports